import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { VersionApiService } from './version-api.service';

@Injectable({ providedIn: 'root' })
export class VersionFacadeService {
  private api = inject(VersionApiService);

  public backendVersion$: Observable<string | null> = this.api.getVersion().pipe(
    map((v) => v.assemblyVersion || null),
    catchError((err) => {
      console.error('Failed to load backend version', err);
      return of(null);
    }),
    shareReplay(1),
  );
}
